// src/components/profile/ExecutiveOverview/NextActions.jsx
import React from 'react';

export default function NextActions({ actions = [] }) {
  // Default actions if none provided
  const defaultActions = [
    { text: 'Schedule stakeholder alignment meeting', owner: 'PMO', days: '3' },
    { text: 'Complete technical feasibility assessment', owner: 'IT', days: '7' },
    { text: 'Review ROI projections with finance team', owner: 'Finance', days: '5' }
  ];
  
  const displayActions = actions.length > 0 ? actions : defaultActions;
  
  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-slate-900 mb-3">
        Immediate Next Steps
      </h3>
      <ol className="space-y-3">
        {displayActions.slice(0, 3).map((action, i) => (
          <li key={i} className="flex items-start gap-3">
            <span className="flex-shrink-0 w-6 h-6 bg-blue-50 text-blue-700 rounded-full flex items-center justify-center text-xs font-semibold">
              {i + 1}
            </span>
            <div className="flex-1">
              <p className="text-sm text-slate-700">{action.text || action}</p>
              {(action.owner || action.days) && (
                <div className="flex gap-2 mt-1">
                  {action.owner && (
                    <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium bg-slate-100 text-slate-600 rounded">
                      {action.owner}
                    </span>
                  )}
                  {action.days && (
                    <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium bg-amber-50 text-amber-700 rounded">
                      {action.days} days
                    </span>
                  )}
                </div>
              )}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}